export class HabitLoggerModel {
   public HabitLoggerId:number;
   public HabitId:number;
   public Created:Date
   public CreatedDisplay:string;
   public NumberOfTimes:number;
   public NumberOfMinutes:number;
   public NumberOfHours:number;
}
